module.exports = __webpack_public_path__ + "img/eps.ce6984dc.svg";